export function paramsToJson(paramsString: any) {
    const params = new URLSearchParams(paramsString)
    const result: any = {}
    
    for (let [key, value] of params) {
        const decodedKey: any = decodeURIComponent(key)
        const decodedValue: any = decodeURIComponent(value)
        
        if (decodedKey.includes('[') && decodedKey.includes(']')) {
            setNestedValue(result, decodedKey, decodedValue)
        } else {
            if (result.hasOwnProperty(decodedKey)) {
                if (!Array.isArray(result[decodedKey])) {
                    result[decodedKey] = [result[decodedKey]]
                }
                result[decodedKey].push(decodedValue)
            } else {
                result[decodedKey] = decodedValue
            }
        }
    }
    
    return result
}

function setNestedValue(obj: any, path: any, value: any) {
    const keys = parseBracketNotation(path)
    let current = obj
    
    for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i]
        const nextKey: any = keys[i + 1]
        
        if (!current[key]) {
            if (nextKey === '' || (!isNaN(nextKey) && nextKey !== '')) {
                current[key] = []
            } else {
                current[key] = {}
            }
        }
        current = current[key]
    }
    
    const lastKey: any = keys[keys.length - 1]
    
    if (lastKey === '') {
        current.push(value)
    } else if (!isNaN(lastKey)) {
        const index = parseInt(lastKey)
        current[index] = value
    } else {
        if (current.hasOwnProperty(lastKey)) {
            if (!Array.isArray(current[lastKey])) {
                current[lastKey] = [current[lastKey]]
            }
            current[lastKey].push(value)
        } else {
            current[lastKey] = value
        }
    }
}

function parseBracketNotation(path: any) {
    const keys = []
    let current = ''
    let inBrackets = false
    
    for (let char of path) {
        if (char === '[') {
            if (current) {
                keys.push(current)
                current = ''
            }
            inBrackets = true
        } else if (char === ']') {
            keys.push(current)
            current = ''
            inBrackets = false
        } else {
            current += char
        }
    }
    
    if (current && !inBrackets) {
        keys.push(current)
    }
    
    return keys
}